import React from 'react';
import PropTypes from 'prop-types';

function Spinner({ withPadding = false }) {
  return (
    <div className={`c-spinner ${withPadding ? 'c-spinner__spinner--padding' : ''}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 70 70"
        enableBackground="new 0 0 0 0"
        xmlSpace="preserve"
      >
        <circle fill="#000" stroke="none" cx="6" cy="35" r="6">
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 15 ; 0 -15; 0 15"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle fill="#000" stroke="none" cx="30" cy="35" r="6">
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 10 ; 0 -10; 0 10"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
        <circle fill="#000" stroke="none" cx="54" cy="35" r="6">
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5 ; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
      </svg>
    </div>
  );
}

Spinner.propTypes = {
  withPadding: PropTypes.bool,
};

export default Spinner;
